import Link from "next/link";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export const siteNavLinkClassName =
  "text-sm font-medium text-blue-600 transition-colors hover:text-blue-700";

interface SiteNavLinkProps {
  href: string;
  children: ReactNode;
  onNavigate?: () => void;
  className?: string;
}

export function SiteNavLink({
  href,
  children,
  onNavigate,
  className,
}: SiteNavLinkProps) {
  return (
    <Link
      href={href}
      onClick={onNavigate}
      className={cn(siteNavLinkClassName, className)}
    >
      {children}
    </Link>
  );
}
